<div class="button-toggle-group__tabs">
  @for (tab of tabs(); track tab.key) {
    <div
      class="button-toggle-group__tab"
      [class.active]="control().value === tab.key"
      (click)="changeTab(tab)"
    >
      {{ tab.label }}
    </div>
  }
</div>
